import React from 'react';
import { Page, Text, View, Document, Image, StyleSheet } from '@react-pdf/renderer';

// Create styles
const styles = StyleSheet.create({
  page: {
    width: '100%',
    flexDirection: 'column',
    backgroundColor: '#ffff',
    padding: 40,
    alignContent: 'center',
  },
  model: {
    flexDirection: 'column',
    width: 150,
    height: 180,
    marginVertical: 10,
    marginHorizontal: 18,
    backgroundColor: '#f0f0f0',
  },
  image: {
    width: '100%',
    height: 'auto',
    objectFit: 'cover',
  },
  images: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    width: '100%',
  },
  modelname: {
    padding: 5,
    flexDirection: 'column',
    textAlign: 'left',
    width: '100%',
    fontSize: 10,
    marginBottom: 20,
  },
  line: {
    marginTop: 'auto',
    borderBottomWidth: 1,
    borderBottomColor: '#000000',
    borderBottomStyle: 'solid',
    width: '40%',
  },
  infoText: {
    textAlign: 'left',
    fontSize: 15,
    marginHorizontal: 25,
    marginVertical: 4,
  }
});

// Create Document Component
const PDFModelPage = ({ model = {}, assets = null}) => {

  console.log("pdf-model", model);


    {/* One page per model with up to 8 images */}
      const allImages = [
        ...(assets?.primaryImages || model?.primaryImages || []),
        ...(assets?.secondaryImages || model?.secondaryImages || []),
      ].slice(0, 8);

      return (
        <Page
          key={model.id + '-casting'}
          size="A4"
          orientation="landscape"
          style={styles.page}
        >
          <View style={styles.modelname}>
            <Text>{model.firstName || 'N/A'}</Text>
            <Text>{model.lastName || 'N/A'}</Text>
            <Text>{`Id: ${model.internalId || 'N/A'}`}</Text>
          </View>

          <View style={styles.images}>
            {allImages.map((img, index) => (
              <View style={styles.model} key={img.file + '-' + index}>
                <Image style={styles.image} src={img.file} />
              </View>
            ))}
          </View>
          <View style={styles.images}>
            <Text style={styles.infoText}>height / {model.height || 'N/A'}</Text>
            <Text style={styles.infoText}>hips / {model.hips || 'N/A'}</Text>
            <Text style={styles.infoText}>waist / {model.waist || 'N/A'}</Text>
            <Text style={styles.infoText}>shoes / {model.shoeSize || 'N/A'}</Text>
            <Text style={styles.infoText}>chest / {model.chest || 'N/A'}</Text>
            <Text style={styles.infoText}>eyes / {model.eyes || 'N/A'}</Text>
            <Text style={styles.infoText}>hair / {model.hair || 'N/A'}</Text>
          </View>

          <View style={styles.line} />
        </Page>
      );
};

export default PDFModelPage;
